import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import moment from 'moment';
import fanoutClient from '../../../utils/FanoutClient';
import ClickOutside from '../../Widget/ClickOutside';
import * as roomActions from "../../../reducers/room";

class ExitModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      knockRid: null,
      notGrantedId: null
    }

    this.clearData = this.clearData.bind(this);
    this.extendCall = this.extendCall.bind(this);
    this.letEventContinue = this.letEventContinue.bind(this);
    this.reloadPage = this.reloadPage.bind(this);
  }

  componentDidMount() {
    const { knocks, getCallState } = this.props;

    if (Object.keys(knocks).length) {
      let callState = getCallState(), id = null, notGrantedId = null;

      Object.keys(knocks).map((key) => {
        if (knocks[key] && callState && knocks[key].uid === callState.uid) {
          if (knocks[key].accepted) {
            id = knocks[key].rid;
          } else {
            notGrantedId = knocks[key].rid;
          }
        }
        return key;
      });

      this.setState({
        knockRid: id,
        notGrantedId: notGrantedId
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { knocks, getCallState, goingOut } = this.props;

    let callState = getCallState(), id = null, notGrantedId = null;
    if (JSON.stringify(knocks) && JSON.stringify(knocks) !== JSON.stringify(prevProps.knocks)) {
      if (Object.keys(knocks).length) {
        Object.keys(knocks).map((key) => {
          if (knocks[key] && callState && knocks[key].uid === callState.uid) {
            if (knocks[key].accepted) {
              id = knocks[key].rid;
            } else {
              notGrantedId = knocks[key].rid;
            }
          }
          return key;
        });
      }

      this.setState({
        knockRid: id,
        notGrantedId: notGrantedId
      });
    }

    // if (goingOut && goingOut !== prevProps.goingOut) {
    //   this.clearData()
    // }
  }

  clearData() {
    const { knockRid, notGrantedId } = this.state;
    const { leave } = this.props;

    if (leave) {
      leave();
    }

    if (knockRid) {
      this.handleRevokeUser(knockRid);
    }

    if (notGrantedId) {
      this.handleRevokeUser(notGrantedId);
    }
  }

  handleRevokeUser(rid) {
    const { getCallState } = this.props;
    if (rid && getCallState) {
      fanoutClient.sendKnockRevoked(rid, getCallState());
    }
  }

  extendCall() {
    const { eventId } = this.props;

    let timestamp = moment(new Date()).add(1, 'hours').valueOf(), alias = eventId ? eventId : null;
    fanoutClient.sendExtendCall(timestamp, alias);
  }

  letEventContinue() {
    if (this.getHostLength() > 1) {
      this.reloadPage();
    } else {
      const { showExitModal } = this.props;

      if (showExitModal) {
        showExitModal(false, true);
      }
    }
  }

  reloadPage() {
    const { showExitModal } = this.props;

    if (showExitModal) {
      showExitModal(false, false);
    }

    setTimeout(() => {
      window.location.reload();
    }, 2000);
  }

  getHostLength() {
    const { hosts } = this.props;
    let retVal = 0;

    if (hosts && Object.entries(hosts).length) {
      Object.entries(hosts).map(([id, participant], i) => {
        if (participant && participant.role === 'presenter') {
          ++retVal;
        }

        return id;
      })
    }

    return retVal;
  }

  render() {
    const { knockRid } = this.state;
    const { modalEventOverrun, role, streamed, exitModal, continueModal, showExitModal } = this.props;

    return (
      <Fragment>
        {continueModal ?
          <div className='hangup-modal-wrapper'>
            <ClickOutside
              className='hangup-modal'
              clickOutside={() => showExitModal(exitModal, false)}
            >
              <div className='hangup-text continue'>You are the only host remaining in the event. When you leave, if the event is without a host for 5 minutes, the event will end automatically for all participants.</div>
              {role && ((role === 'presenter') || (role === 'moderator')) && streamed ?
                <button
                  className='btn hangup-end'
                  onClick={this.reloadPage}
                >
                  Ok
                </button>
                : null}
              <button
                className='btn hangup-cancel'
                onClick={() => showExitModal(exitModal, false)}
              >
                Cancel
              </button>
            </ClickOutside>
          </div>
          : exitModal ?
            <div className='hangup-modal-wrapper'>
              <ClickOutside
                className='hangup-modal'
                clickOutside={() => showExitModal(false, false)}
              >
                <div className='hangup-title'>{role && ((role === 'presenter') || (role === 'moderator')) && streamed ? 'Leave and..' : 'Confirm Exit'}</div>
                {knockRid ?
                  <button
                    className='btn hangup-exit'
                    onClick={() => {
                      this.handleRevokeUser(knockRid);
                      showExitModal(false, false);
                    }}
                  >
                    Move To Audience
                  </button>
                  :
                  null}
                <button
                  className='btn hangup-end'
                  onClick={this.clearData}
                >
                  {role && ((role === 'presenter') || (role === 'moderator')) && streamed ? 'End event for everyone' : 'Exit Stream'}
                </button>
                {role && ((role === 'presenter') || (role === 'moderator')) && streamed ?
                  <button
                    className='btn hangup-end'
                    onClick={this.letEventContinue}
                  >
                    Let event continue
                  </button>
                  : null}
                <button
                  className='btn hangup-cancel'
                  onClick={() => showExitModal(false, false)}
                >
                  Cancel
                </button>
              </ClickOutside>
            </div>
            : null}
        {/* {modalEventOverrun ?
          <div className='overlay-modal-wrapper'>
            <div className='overlay-modal big-modal'>
              <div className='overlay-title'>Event Overrun</div>
              <div className='overlay-text'>This event has significantly run over the original time. Do you want the event to continue?</div>
              <button
                className='btn overruns-yes'
                onClick={this.extendCall}
              >
                Yes
              </button>
              <button
                className='btn overruns-no'
                onClick={this.clearData}
              >
                No
              </button>
            </div>
          </div>
          : null} */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    knocks: state.knocks,
    hosts: state.hosts,
    modalEventOverrun: state.room.modalEventOverrun,
    goingOut: state.room.goingOut,
    streamed: state.room.streamed,
    exitModal: state.room.exitModal,
    continueModal: state.room.continueModal
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showExitModal: (exitVal, continueVal) => {
      dispatch(roomActions.showExitModal({ exitModal: exitVal, continueModal: continueVal }));
    }
  };
};

const ExitModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ExitModal);

export default ExitModalContainer;
